import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCartData } from 'store/cartSlice/selectors';

const SeatsCountdownTimer: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { holdToken } = useSelector(selectCartData);
  const defaultValue = Math.round(
    DateTime.fromISO(holdToken?.endTime).diffNow('seconds').seconds,
  );
  const [secondsRemaining, setSecondsRemaining] = useState(defaultValue);

  window.onfocus = () => {
    if (defaultValue > 0) {
      setSecondsRemaining(defaultValue);
    } else {
      setSecondsRemaining(0);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsRemaining(secondsRemaining => secondsRemaining - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const secondsToDisplay = secondsRemaining % 60;
  const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60;
  const minutesToDisplay = minutesRemaining % 60;

  return (
    <div className="countdown-container mx-auto sm:mx-0 flex gap-1 items-center justify-center flex-wrap">
      <p className="p2-regular text-neutral-800">
        {t('registrationPage.seatsExpirationMessage')}
      </p>
      <p className="p2-semibold mx-auto md:mx-0 w-fit min-w-[48px] rounded-sm text-center text-red-1000 bg-red-20">
        {secondsRemaining > 0
          ? `${minutesToDisplay.toString().padStart(2, '0')}:${secondsToDisplay
              .toString()
              .padStart(2, '0')}`
          : '00:00'}
      </p>
    </div>
  );
};

export default SeatsCountdownTimer;
